/*
 * Copyright (C) 2018 envisia GmbH
 * All Rights Reserved.
 */
import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Address} from '../../../customer/model/address';
import {Workflow} from '../../models/workflow.models';
import {Customer} from '../../../customer/model/customer';
import {Country} from '../../../customer/model/country';
import {CountryService} from '../../../customer/services/country.service';
import {map} from 'rxjs/operators';
import {LoadingWrapper} from '../../../../common/loading/loading-wrapper';
import {PriceIncreaseFlex} from '../../models/price-increase-flex.model';
import {noop} from '../../../../helper/noop';
import {BigFetchWithCleanPosition} from './fetch-box.model';
import {MergedFrame} from '../../models/frame.models';
import {UIRouterGlobals} from '@uirouter/core';
import {NumberHelper} from '../../../../helper/number-helper';

@Component({
    selector: 'fetch-box',
    templateUrl: './fetch-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FetchBoxComponent implements OnInit {
  @Input() workflow: Workflow;
  @Input() customer: Customer;
  @Input() addresses: Address[];
  @Input() fetches: BigFetchWithCleanPosition[];
  @Input() frame: MergedFrame;
  @Input() priceIncreaseFlex?: PriceIncreaseFlex;
  @Input() selectedScrollToFetchId: number | null = null;
  @Output() statusChange = new EventEmitter<number>();
  @Output() reloadFetches: EventEmitter<void> = new EventEmitter<void>();

  isoCountryLoader: LoadingWrapper<Country | null | undefined>;

  constructor(private countryService: CountryService,
              private uiRouterGlobals: UIRouterGlobals) {
  }

  ngOnInit(): void {
    this.isoCountryLoader = new LoadingWrapper(this.countryService.map().pipe(map(countries => {
      return countries[this.customer.invoice.country];
    })));

    const scrollToAnchor: string | null | undefined = this.uiRouterGlobals.params['#'];
    this.selectedScrollToFetchId = scrollToAnchor?.startsWith('fetch-') && scrollToAnchor.length > 6 ?
      NumberHelper.saveParseInteger(scrollToAnchor.split("-")[1]) :
      null;
  }

  trackById(index: number, obj: BigFetchWithCleanPosition): number {
    noop(this);
    return obj.id;
  }
}
